import React from "react";
import { Link } from "react-router-dom";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import NearMeDisabledRoundedIcon from '@mui/icons-material/NearMeDisabledRounded';
import NavigationRoundedIcon from "@mui/icons-material/NavigationRounded";
import TimelineIcon from '@mui/icons-material/Timeline';
import moment from "moment";
import "./vehicleList.scss"

const VehicleList = ({
    locations,
    filteredLocations,
    selected,
    search,
    searchText,
    setSearchText,
    toggleSearch,
    flyToLocation,
    hasPermission,
}) => {
    return (
        <div className="vehicleList">
            <div className="contentList">
                <div className="scroll">
                    <div className="top">
                        {search ?
                            <div className="left">
                                <input
                                    type="text"
                                    autoFocus
                                    placeholder="Suche"
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                />
                            </div>
                            :
                            <div className="left">
                                <h2>Fahrzeuge</h2>
                                <span>{locations.length}</span>
                            </div>
                        }
                        <div className="right">
                            <SearchRoundedIcon onClick={toggleSearch} />
                        </div>
                    </div>
                    <div className="list">
                        {filteredLocations.map(item => (
                            <div
                                className={selected === item.id ? "item active" : "item"}
                                key={item.id}
                                onClick={() => flyToLocation({ coordinates: [item.longitude, item.latitude], properties: item })}
                            >
                                <div className={item.ignition ? "badge go" : "badge stop"}>
                                    <NavigationRoundedIcon />
                                </div>
                                <div className="data">
                                    <span className="alias">{item.itemAlias} - {item.itemDescription}</span>
                                    <span className="driver">{item.itemDriverAlias}</span>
                                    <div className="bottom">
                                        <div className="infoBox">
                                            {item.itemKennzeichen &&
                                                <div className="kennzeichen">
                                                    <span>{item.itemKennzeichen}</span>
                                                </div>
                                            }
                                            <div className="timestamp">
                                                <span>{moment(item.recivedAt).fromNow()}</span>
                                            </div>
                                        </div>
                                        {hasPermission("timeline", "read") &&
                                            <Link className={item.ignition ? "timeline go" : "timeline stop"} to={`timeline/${item.id}`} title="Zeitachse" >
                                                <TimelineIcon />
                                            </Link>
                                        }
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                {locations.length === 0 &&
                    <div className="empty">
                        <NearMeDisabledRoundedIcon />
                        <span>Keine Tracker in dieser Kategorie</span>
                    </div>
                }
            </div>
        </div>
    );
};

export default VehicleList;